<template>
    <div class="popup popup--mini" @mousedown.self="$emit('close')">
        <div class="popup__block">
            <div class="popup__top">
                <div class="popup__title">Скопировать {{tender?.type?.code === 'CO' ? 'запрос' : 'тендер'}} №{{ tender?.id }}?</div>
                <div class="popup__close" @click="$emit('close')"></div>
            </div>
            <div class="popup__content">
                <div class="popup__btns">
                    <button class="btn btn--color" @click="handleSubmit">Да</button>
                    <button class="btn btn--border" @click="$emit('close')">Нет</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import {mapActions} from "vuex";
import {useToast} from "vue-toastification";

export default {
    name: 'СopyTenderPopup',
    emits: ['close'],
    props: {
        tender: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            toast: useToast(),
        }
    },

    methods: {
        async handleSubmit() {
            const res = await this.requestCopyTender(this.tender?.id);
            if (res.success) {
                this.toast.success(`${this.tender?.type?.code === 'CO' ? 'Запрос' : 'Тендер'} успешно скопирован`);
                setTimeout(() => window.location.href = `/personal/tenders/?ID=${res.data}`, 1500)
            }
            this.$emit('close');
        },
        ...mapActions({
            requestCopyTender: 'tenders/requestCopyTender',
        })
    }
}
</script>
